export const checkPostcodeValidCharacters = (postcode: string) => {
  if (/[^a-zA-Z0-9]/.test(postcode.replaceAll(" ", ""))) return false;

  if (postcode.length < 3) return true;

  return [...postcode.trim()]
    .slice(0, 3)
    .some((character) => !Number.isNaN(Number(character)) && character !== " ");
};
